import { useState } from 'react';
import * as Yup from 'yup';
import { Auth } from 'aws-amplify';
import { useNavigate } from 'react-router-dom';
import { gql } from '@apollo/client';
import useValidationMessages from '../../helpers/useValidationMessages';
import SignUpView from './View';
import { useIntl } from 'react-intl';

export const CREATE_USER = gql`
  mutation CreateUser($input: UserInput!) {
    createUser(input: $input) {
      id
    }
  }
`;

const SignUp = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();

  const [showPrivacyPolicyModal, setShowPrivacyPolicyModal] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);

  const [checked, setChecked] = useState(false);
  const [checkError, setCheckError] = useState(false);

  const { tooShortName, tooShortPassword, required, invalidEmailAddress } =
    useValidationMessages();

  const intl = useIntl();

  const initialValues = {
    name: '',
    email: '',
    password: '',
    phone: '',
  };

  const startsWithSpecialChars = /^\+{1}.*/;

  const validationSchema = Yup.object().shape({
    name: Yup.string().min(2, tooShortName).max(50).required(required),
    email: Yup.string().email(invalidEmailAddress).required(required),
    password: Yup.string().min(8, tooShortPassword).required(required),
    phone: Yup.string().matches(
      startsWithSpecialChars,
      intl.formatMessage({
        defaultMessage: 'Måste starta med landskod, t.ex. +46',
      }),
    ),
  });

  const handleSignUp = async ({ email, name, password, phone }) => {
    if (!checked) {
      setCheckError(true);
      setLoading(false);
      return;
    }

    setLoading(true);

    const newsletter = 1;

    try {
      const { user } = await Auth.signUp({
        username: email,
        password,
        attributes: {
          name,
          email,
          'custom:school_id': '22',
          phone_number: phone.toString(),
        },
        clientMetadata: {
          newsletter: newsletter.toString(),
        },
        autoSignIn: {
          enabled: false,
        },
      });

      if (process.env.STAGE === 'local') {
        // create user with Apollo client to API
        // todo
      }

      navigate(`/sign-up-successful?username=${user.username}`);
    } catch (error) {
      console.log('error signing up:', error);
      setLoading(false);
      setError(error?.code || 'UnknownError');
    }
  };

  const openModal = (modalName) => {
    if (modalName === 'privacyPolicy') {
      setShowPrivacyPolicyModal(true);
    }

    if (modalName === 'userAgreement') {
      setShowTermsModal(true);
    }
  };

  return (
    <SignUpView
      handleSignUp={handleSignUp}
      loading={loading}
      setLoading={setLoading}
      error={error}
      checkError={checkError}
      setCheckError={setCheckError}
      setChecked={setChecked}
      checked={checked}
      showPrivacyPolicyModal={showPrivacyPolicyModal}
      setShowPrivacyPolicyModal={setShowPrivacyPolicyModal}
      showTermsModal={showTermsModal}
      setShowTermsModal={setShowTermsModal}
      initialValues={initialValues}
      validationSchema={validationSchema}
      openModal={openModal}
    />
  );
};

export default SignUp;
